import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useState } from 'react';
import { subMonths } from 'date-fns';
import { useDeleteSystemLogs } from './api/deleteSystemLogs';
import { useUserDateTime } from '../timezone/hooks/useUserDateTime';
import { formatInTimeZone } from 'date-fns-tz';

interface Props {
  open: boolean;
  handleClose: () => void;
}

const PurgeSystemLogsDialog = ({ open, handleClose }: Props) => {
  const [toDate, setToDate] = useState<Date | null>(subMonths(new Date(), 1));
  const { timezone } = useUserDateTime();

  const handleCancel = () => {
    handleClose();
  };

  const purgeSystemLogs = useDeleteSystemLogs({});

  const handleSubmit = () => {
    const purgeDate = toDate
      ? formatInTimeZone(toDate, timezone, 'yyyy-MM-dd')
      : formatInTimeZone(new Date(), timezone, 'yyyy-MM-dd');
    purgeSystemLogs.mutate(purgeDate);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
      <DialogTitle>Purge System Logs</DialogTitle>
      <DialogContent style={{ paddingTop: '1rem' }}>
        <LocalizationProvider
          style={{ paddingTop: '.2rem' }}
          dateAdapter={AdapterDateFns}
        >
          <DatePicker
            label='Purge Before'
            maxDate={new Date()}
            inputFormat='MM/dd/yyyy'
            value={toDate}
            onChange={(e) => setToDate(e)}
            renderInput={(params) => <TextField {...params} fullWidth />}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color='secondary' variant='contained'>
          Cancel
        </Button>
        <Button color='primary' onClick={handleSubmit} variant='contained'>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PurgeSystemLogsDialog;
